import { Fragment } from 'react';
import { t } from '@lingui/core/macro';
import { Box, Checkbox, Chip } from '@pocketlaw/tetris';
import { useFormikContext } from 'formik';
export function FieldSelection(props) {
    const { fields } = props;
    const { values, setFieldValue } = useFormikContext();
    const { selectedIds } = values;
    const allFieldIds = fields.map((field) => field.id);
    const allSelected = allFieldIds.length > 0 && selectedIds.length === allFieldIds.length;
    const someSelected = selectedIds.length > 0 && selectedIds.length < allFieldIds.length;
    const toggleAll = () => {
        setFieldValue('selectedIds', allSelected ? [] : allFieldIds);
    };
    const toggleOne = (id) => {
        setFieldValue('selectedIds', selectedIds.includes(id) ? selectedIds.filter((value) => value !== id) : [...selectedIds, id]);
    };
    return (<Fragment>
      <Checkbox checked={allSelected} indeterminate={someSelected} onChange={toggleAll} label={t({
            message: 'Select all',
            comment: 'HubSpot metadata: select all fields',
        })}/>

      {fields.map((field) => (<Box key={field.id} alignItems="center" gap="md" justifyContent="space-between">
          <Checkbox checked={selectedIds.includes(field.id)} onChange={() => toggleOne(field.id)} label={field.label}/>
          <Chip label={field.value} size="small" appearance="secondary"/>
        </Box>))}
    </Fragment>);
}
